export {default as Checkbox} from './checkbox';
export {default as Text} from './text';



// WEBPACK FOOTER //
// ./src/input-display/index.js